// 👉 React → Android calls
export const APP_METHODS = Object.freeze({
  CLOSE_APP: "closeApp",
  HAS_REQUIRED_PERMISSIONS: "checkAllPermissionsEnabled",
  // Permissions Related Methods (START)
  REQUEST_REQUIRED_PERMISSIONS: "enablePermissions",
  REQUEST_CAMERA_AND_MIC_PERMISSIONS: "enableCameraAndMicrophonePermissions",
  REQUEST_NOTIFICATION_PERMISSIONS: "enableNotificationPermissions",
  REQUEST_LOCATION_PERMISSIONS: "enableLocationPermissions",
  REQUEST_CAMERA_PERMISSIONS: "enableCameraPermissions",
  REQUEST_MICROPHONE_PERMISSIONS: "enableMicrophonePermissions",
  CHECK_CAMERA_AND_MIC_PERMISSIONS: "checkCameraAndMicrophonePermissionsEnabled",
  CHECK_NOTIFICATION_PERMISSIONS: "checkNotificationPermissionsEnabled",
  CHECK_LOCATION_PERMISSIONS: "checkLocationPermissionsEnabled",
  CHECK_CAMERA_PERMISSIONS: "checkCameraPermissionsEnabled",
  CHECK_MICROPHONE_PERMISSIONS: "checkMicrophonePermissionsEnabled",
  CHECK_GPS_STATUS: "checkGpsEnabled",
  OPEN_GPS_SETTINGS: "openGpsSettings",
  OPEN_NETWORK_SETTINGS: "openNetworkSettings",
  OPEN_APP_SETTINGS: "goToSettings",
  // Permissions Related Methods (END)
  FETCH_LOCATION_DETAILS: "getLocationDetails",
  FETCH_DEVICE_DETAILS: "getDeviceDetails",
  FETCH_APP_DETAILS: "getAppDetails",
  GET_SOURCE_ATTRIBUTION: "getSourceAttribution",
  START_GOOGLE_SIGN_IN: "loadGoogleSignIn",
  FETCH_FCM_TOKEN: "loadFCMToken",
  GET_AUTO_READ_PHONE_NUMBER: "getAutoReadPhoneNumber",
  GET_AUTO_READ_PHONE_SMS: "getAutoReadPhoneSms",
  LOAD_WEBVIEW_URL: "loadWebViewUrl",
  OPEN_PLAY_STORE: "openPlayStore",
  SET_STATUS_BAR_BACKGROUND: "statusBarBackgroundColorChange",
  EMAIL_USER: "emailUser",
  LOG_LOGIN_EVENT: "logLoginEvent",
});

// 👉 Android → React events
export const NATIVE_EVENTS = Object.freeze({
  BACK_PRESS: "handleNativeBackPress",
  PERMISSIONS_DENIED: "failedToProvidePermissions",
  PERMISSIONS_GRANTED: "permissionsProvidedInAndroid",
  GOOGLE_SIGN_IN_SUCCESS: "googleSignInSuccess",
  FCM_TOKEN: "fcmToken",
  FCM_TRIGGERED: "fcmTriggered",
  GET_APP_DETAILS_RESULTS: "getAppDetailsResults",
  GET_DEVICE_DETAILS_RESULTS: "getDeviceDetailsResults",
  GET_LOCATION_DETAILS_RESULTS: "getLocationDetailsResults",
  SOURCE_ATTRIBUTION_RESULT: "sourceAttributionResult",
  AUTO_READ_PHONE_NUMBER_RESULT: "autoReadPhoneNumberResult",
  AUTO_READ_PHONE_SMS_RESULT: "autoReadPhoneSmsResult",
  PROMPT_USER_TO_OPEN_SETTINGS: "promptUserToOpenSettings",
  NETWORK_STATUS_CHANGED: "onNetworkStatusChanged",
  GPS_STATUS_CHANGED: "onGpsStatusChanged",
  BRANCH_TRAFFIC_DATA: "branchTrafficData",
});
